const DrupalOAuth = require("./DrupalOAuth");

module.exports = async function handleLogin(authContext, ev) {
	const [state, dispatch] = authContext;
	const auth = new DrupalOAuth(state);
	const formData = new FormData(ev.target);
	const token = await auth.loginUser(formData, "password");
	if (token && token.token) {
		dispatch({
			type: "AUTHENTICATE_USER",
			payload: {
				isAuthenticated: true,
				clientId: auth.getClientId(),
				baseUrl: auth.getBaseUrl(),
			},
		});
	} else {
		//TODO: inform the user that they failed to log in.
		return false;
	}
};
